import { MessageStatusComponent } from '@klant/conversational/conversational-chat-message/message-status/message-status.component';
import { MessageCtaComponent } from '@klant/conversational/conversational-chat-message/message-cta/message-cta.component';
import { MessageTimestampComponent } from '@klant/conversational/conversational-chat-message/message-timestamp/message-timestamp.component';
import { MessageDateDividerComponent } from '@klant/conversational/conversational-chat-message/message-date-divider/message-date-divider.component';
import { RelativeDatePipe } from '@klant/conversational/conversational-chat-message/message-date-divider/pipe/relative-date.pipe';

import { NgModule } from '@angular/core';
import { NgClass } from '@angular/common';

import { ApIconComponent } from '@ap/icon';
import { ApChatBubbleComponent } from '@ap/chat-bubble';
import { ApIllustrationComponent } from '@ap/illustration';
import { ApButtonComponent, ApButtonLinkComponent } from '@ap/button';
import { ApContentPipe } from '@ap/content';

import { ConversationalChatMessageComponent } from './conversational-chat-message.component';
import { ConversationalChatMessageDirective } from './conversational-chat-message.directive';
import { MessageChoiceOptionComponent } from './message-choice-option/message-choice-option.component';
import { MessageChoicePromptComponent } from './message-choice-prompt/message-choice-prompt.component';
import { MessageLoaderComponent } from './message-loader/message-loader.component';
import { MessageMessageComponent } from './message-message/message-message.component';
import { MessageDividerComponent } from './message-divider/message-divider.component';

/**
 * @ngdoc module
 * @name ConversationalChatMessageModule
 **/
@NgModule({
    declarations: [
        ConversationalChatMessageComponent,
        ConversationalChatMessageDirective,
        MessageChoiceOptionComponent,
        MessageChoicePromptComponent,
        MessageLoaderComponent,
        MessageMessageComponent,
        MessageStatusComponent,
        MessageTimestampComponent,
        MessageDividerComponent,
        MessageDateDividerComponent,
        MessageCtaComponent
    ],
    exports: [
        ConversationalChatMessageComponent,
        MessageLoaderComponent,
        MessageStatusComponent,
        MessageCtaComponent,
        MessageDateDividerComponent
    ],
    imports: [
        ApIconComponent,
        ApChatBubbleComponent,
        ApIllustrationComponent,
        ApButtonComponent,
        ApButtonLinkComponent,
        ApContentPipe,
        RelativeDatePipe,
        NgClass
    ]
})
export class ConversationalChatMessageModule {}
